import React, {Component} from "react";
import {BrowserRouter as Router, Switch, withRouter} from "react-router-dom";
// Import Routes
import {generateRoutes} from "./routes/";
import AppRoute from "./routes/route";
// layouts
import HorizontalLayout from "./components/HorizontalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";
// Import scss
import "./assets/scss/theme.scss";
import {connect} from "react-redux";
import {getDelegatee, getDelegator, getProfile} from "./store/auth/user/actions";
import {getEnvironmentVariables} from "./store/auth/variables/actions";
import {getTokens} from "./store/auth/tokens/actions";
import {
    getAgentsAction,
    getBdsAction,
    getClientsAction,
    getCustodiansAction,
    getGroupsAction,
    getRiasAction
} from "./store/info/actions";
import Loader from "./components/CommonForBoth/Loader";
import {isLegacySubdomain, isTrustedLegacyOrigin} from "./helpers/Util";
import LegacySubdomainRedirect from "./components/CommonForBoth/LegacySubdomainRedirect";
import QueryString from "qs";

window.onload = () => {
    window.opener?.postMessage("READY", "*");
    window.addEventListener("message", (event) => {
        const isLocalDev = event.origin === "localhost:3000";
        // Security check: Ensure the message is from the expected origin
        if (!isLocalDev && !isTrustedLegacyOrigin(event.origin)) {
            //console.warn("Blocked message from unauthorized origin:", event.origin);
            return;
        }

        // Ensure event data is valid
        if (isLocalDev || (event.data && typeof event.data === "object" && event.data.user)) {
            localStorage.setItem("authUser", JSON.stringify(event.data.user));
            window.location.href = event.data.user.mfaVersion ? "/" : "/profile?mfa=1";
        }
    }, false);
};

class App extends Component {
    constructor(props) {
        super(props);
        const authUser = JSON.parse(localStorage.getItem("authUser"));
        this.state = {
            authProtectedRoutes: [],
            publicRoutes: [],
            fetchedTokens: false,
            authUser: authUser || false
        };
        if (authUser) {
            const secRemaining = (authUser.expires - Date.now()) / 1000;
            if (secRemaining > 0) {
                props.getTokens();
                props.getProfile(props.history);
                props.getDelegator();
                props.getDelegatee();
                props.getCustodiansAction();
                props.getBdsAction();
                props.getRiasAction();
                props.getAgentsAction();
                props.getClientsAction();
                props.getGroupsAction();
            }
        }

        setInterval(() => {
            const authUser = JSON.parse(localStorage.getItem("authUser"));
            if (authUser) {
                const secRemaining = (authUser.expires - Date.now()) / 1000;
                if (secRemaining < 0) {
                    if (this.state.authProtectedRoutes.some(r => r.path === window.location.pathname)) {
                        window.location = "/login?error=timeout";
                    }
                    localStorage.removeItem("authUser");
                }
            }
        }, 5000);
        this.updateRoutes = this.updateRoutes.bind(this);
    }

    componentDidMount() {
        this.updateRoutes();
        this.fetchTokens();
    }

    componentDidUpdate(prevProps) {
        const authUser = JSON.parse(localStorage.getItem("authUser"));
        if ((prevProps.profile !== this.props.profile) || (prevProps.org !== this.props.org)) {
            this.updateRoutes();
        }
        // avoid rerender and refetch of tokens
        if (!this.state.fetchedTokens) this.fetchTokens();
        if (authUser?.email !== this.state.authUser?.email) this.setState({ authUser });
    }

    fetchTokens() {
        if (!this.state.fetchedTokens) {
            this.props.getTokens();
            this.setState({ fetchedTokens: true });
        }
    }

    updateRoutes() {
        const {authProtectedRoutes, publicRoutes} = generateRoutes();
        this.setState({authProtectedRoutes, publicRoutes});
    }

    render() {
        const query = QueryString.parse(window.location.search.substring(1));
        const {authProtectedRoutes, publicRoutes, authUser} = this.state;
        if (this.props.loading || query.loading) return <Loader show message="Loading"/>;
        if (isLegacySubdomain(window.location) && authUser) {
            return <LegacySubdomainRedirect history={this.props.history} migrated={authUser.mfaVersion} />;
        }
        return (
            <React.Fragment>
                <Router>
                    <Switch>
                        {publicRoutes.map((route, idx) => (
                            <AppRoute
                                path={route.path}
                                layout={NonAuthLayout}
                                component={route.component}
                                key={idx}
                                isAuthProtected={false}
                            />
                        ))}

                        {authProtectedRoutes.map((route, idx) => (
                            <AppRoute
                                updateRoutes={this.updateRoutes}
                                path={route.path}
                                layout={HorizontalLayout}
                                component={route.component}
                                key={idx}
                                isAuthProtected={true}
                            />
                        ))}
                    </Switch>
                </Router>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    const {profile} = state.User;
    const {org, loading} = state.Variables;
    return {profile, loading, org};
};

export default withRouter(connect(mapStateToProps, {
    getProfile,
    getDelegator,
    getDelegatee,
    getCustodiansAction,
    getBdsAction,
    getRiasAction,
    getAgentsAction,
    getClientsAction,
    getGroupsAction,
    getEnvironmentVariables,
    getTokens
})(App));
